import Vue from 'vue'
import VueRouter from 'vue-router'
import Page from '@/views/Page'

Vue.use(VueRouter)

const Router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Overview',
      component: Page,
      meta: {
        apiPath: `${process.env.VUE_APP_API_ADDRESS}/home`,
        showInMenu: true
      }
    },
    {
      path: '/opportunity',
      name: 'The Opportunity',
      component: Page,
      meta: {
        apiPath: `${process.env.VUE_APP_API_ADDRESS}/opportunity`,
        showInMenu: true
      }
    },
/*
    {
      path: '/financial-summary',
      name: 'Financial Summary',
      component: Page,
      meta: {
        apiPath: `${process.env.VUE_APP_API_ADDRESS}/financial-summary`,
        showInMenu: true
      }
    },
*/
    {
      path: '/new-acton',
      name: 'NewActon',
      component: Page,
      meta: {
        apiPath: `${process.env.VUE_APP_API_ADDRESS}/new-acton`,
        showInMenu: true,
        showInHeader: false,
      }
    },
    {
      path: '/canberra',
      name: 'Canberra',
      component: Page,
      meta: {
        apiPath: `${process.env.VUE_APP_API_ADDRESS}/canberra`,
        showInMenu: true
      }
    },
    {
      path: '/sales-process',
      name: 'Sales Process',
      component: Page,
      meta: {
        apiPath: `${process.env.VUE_APP_API_ADDRESS}/sales`,
        showInMenu: true
      }
    },
    {
      path: '/contacts',
      name: 'Contacts',
      component: Page,
      meta: {
        apiPath: `${process.env.VUE_APP_API_ADDRESS}/contacts`,
        showInMenu: true
      }
    },
    {
      path: '/gallery',
      name: 'Image Gallery',
      component: Page,
      meta: {
        apiPath: `${process.env.VUE_APP_API_ADDRESS}/galleries`,
        showInMenu: true
      }
    },
  ]
})

Router.afterEach((to, from) => {
  if(to.path !== from.path) {
    // scroll to top of window when path changes
    window.scrollTo(0, 0)
  }
})

export default Router
